import { __awaiter, __generator } from "tslib";
import { useContext, useEffect, useReducer, useState, useRef } from 'react';
import { getModule } from '@scalprum/core';
import { RemoteHookContext } from './remote-hook-provider';
export var useRemoteHook = function (_a) {
    var scope = _a.scope, module = _a.module, importName = _a.importName, _b = _a.args, args = _b === void 0 ? [] : _b;
    var _c = useContext(RemoteHookContext), subscribe = _c.subscribe, updateState = _c.updateState, getState = _c.getState, registerHook = _c.registerHook, updateArgs = _c.updateArgs;
    var _d = useReducer(function (x) { return x + 1; }, 0), forceUpdate = _d[1];
    var _e = useState(''), id = _e[0], setId = _e[1];
    useEffect(function () {
        var _a = subscribe(forceUpdate), id = _a.id, unsubscribe = _a.unsubscribe;
        setId(id);
        // Track if component is still mounted
        var isMounted = true;
        // Load the federated hook module
        var loadHook = function () { return __awaiter(void 0, void 0, void 0, function () {
            var hookFunction, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getModule(scope, module, importName)];
                    case 1:
                        hookFunction = _a.sent();
                        // Only update if component is still mounted
                        if (isMounted) {
                            updateArgs(id, args); // Set args before registering hook
                            registerHook(id, hookFunction);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        if (isMounted) {
                            updateState(id, { loading: false, error: error_1 });
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        // Set initial loading state
        updateState(id, { loading: true, error: null });
        loadHook();
        return function () {
            isMounted = false; // Mark as unmounted
            unsubscribe();
        };
    }, [scope, module, importName]);
    // Update args when they change (with shallow comparison)
    var argsRef = useRef(args);
    useEffect(function () {
        if (id) {
            var prevArgs_1 = argsRef.current;
            var hasChanged = args.length !== prevArgs_1.length || args.some(function (arg, index) { return arg !== prevArgs_1[index]; });
            if (hasChanged) {
                argsRef.current = args;
                updateArgs(id, args);
            }
        }
    }, [id, args, updateArgs]);
    var state = getState(id) || { loading: true, error: null };
    return {
        id: id,
        loading: state.loading,
        error: state.error,
        hookResult: state.hookResult,
    };
};
//# sourceMappingURL=use-remote-hook.js.map